import type {
    DatapointOptions,
    CustomData,
    INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT,
} from 'owa-analytics-types';
import VerboseDatapoint from '../datapoints/VerboseDatapoint';
import type { AnalyticsCoreEventNames, AnalyticsEventNames } from 'owa-analytics-events';
import type { MailboxInfo } from 'owa-client-types';

export function logVerboseUsage(
    eventName: AnalyticsEventNames | AnalyticsCoreEventNames,
    mailbox: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined,
    customData?: CustomData,
    options?: DatapointOptions
): void {
    const dp = new VerboseDatapoint(eventName, mailbox, options);
    if (customData) {
        dp.addCustomData(customData);
    }
    dp.end();
}
